import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {LoadSuccessPlayerAdoptionFamiliesAction, playerAdoptionFamiliesActionTypes} from '../actions/player-adoption-families';

export interface FamiliesState {
  // tslint:disable-next-line:no-any
  array: any[];
}

const initialState: FamiliesState = {
  array: undefined
};

export function FamiliesReducer(state: FamiliesState = initialState, action: Action): FamiliesState {
  switch (action.type) {
    case playerAdoptionFamiliesActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case playerAdoptionFamiliesActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    default:
      return state;
  }
}


function handleLoadSuccessAction(state: FamiliesState, action: LoadSuccessPlayerAdoptionFamiliesAction): FamiliesState {
  const newState = _.clone(state);
  newState.array = action.payload;
  return newState;
}

function handleLoadErrorActions(state: FamiliesState): FamiliesState {
  return state;
}


export const familiesSelectors = {
  array: (state: FamiliesState) => _.get(state, 'array', [])
};
